import { AnyAction } from 'redux';

import { reducerWrapper } from '../../support/utils';
import { CreationDialogReducerType } from './Types/CreationDialogReducerType';
import { UPDATE_CREATION_DIALOG } from '../../actions/LinkManager/CreationDialogActions';

export const INIT_STATE: CreationDialogReducerType = {
  open: false,
};

const Handler = (state: CreationDialogReducerType, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_CREATION_DIALOG.response:
      return {
        ...state,
        open: action.data?.open,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const CreationDialogReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [UPDATE_CREATION_DIALOG],
  error: [UPDATE_CREATION_DIALOG],
});

export default CreationDialogReducer;
